import React, { Component, Fragment } from 'react'
import { Portal } from 'react-portal'
import { connect } from 'redaction'
import actions from 'redux/actions'
import cx from 'classnames'
import { snowplow, constants, compose } from 'common/helpers'
import { injectIntl } from 'sb-react-intl'

import CartSidebar from 'components/cart/Sidebar/Sidebar'

import messages from './messages.js'
import s from './HeaderCartButton.scss'


class HeaderCartButton extends Component {

  componentDidMount() {
    // TODO remove it
    actions.models.cart.fetch()
  }

  handleClick = () => {
    snowplow.track(constants.snowplowEvents.cartClick)
    actions.models.cart.open()
  }

  render() {
    const { totalCount, intl, role } = this.props

    const counterClassName = cx(s.cartButton, {
      [s.notEmpty]: Boolean(totalCount),
    })

    const cartLabel = intl.formatMessage(messages.cartLabel)

    return (
      <Fragment>
        <button
          className={counterClassName}
          onClick={this.handleClick}
          type="button"
          role={role}
          aria-label={cartLabel}
        >
          <div className={s.icon} data-testid="cartCounter" id="cartCounter">
            {
              Boolean(totalCount) && (
                <span className={s.counter}>{totalCount}</span>
              )
            }
          </div>
        </button>
        <Portal>
          <CartSidebar />
        </Portal>
      </Fragment>
    )
  }
}


export default compose(
  connect({
    totalCount: 'models.cart.totalCount',
  }),
  injectIntl,
)(HeaderCartButton)
